import { render, staticRenderFns } from "./MaintenanceRequest.vue?vue&type=template&id=4ffd05d2&scoped=true"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=js"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceRequest.vue?vue&type=style&index=0&id=4ffd05d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd05d2",
  null
  
)

export default component.exports